// // src/features/blogs/public/BlogsList.jsx
// import { useState } from 'react';
// import { useGetPublicBlogsQuery } from '../blogsApiSlice';
// import BlogCard from '../components/BlogCard';

// export default function BlogsList() {
//   const [page, setPage] = useState(1);
//   const limit = 9;
//   const { data, isLoading, isError, error, isFetching } = useGetPublicBlogsQuery(
//     { page, limit },
//     {
//       // Add logging to debug
//       onSuccess: (data) => console.log('Query success:', data),
//       onError: (error) => console.log('Query error:', error)
//     }
//   );

//   // Log the raw data to check its structure
//   console.log('Raw data:', data);

//   // Get blogs from the transformed response
//   const blogs = data?.docs || [];
//   const hasNext = data?.hasNextPage;
//   const hasPrev = data?.hasPrevPage;
//   const currentPage = data?.page ?? page;

//   return (
//     <section className="mx-auto max-w-6xl px-4 py-8">
//       <header className="mb-6">
//         <h1 className="text-2xl font-semibold text-gray-900">Company Blog</h1>
//         <p className="text-gray-600">News, insights, and product updates.</p>
//       </header>

//       {isLoading ? (
//         <div className="text-gray-500">Loading…</div>
//       ) : isError ? (
//         <div className="text-red-600">Error: {error?.data?.message ?? 'Failed to load blogs'}</div>
//       ) : blogs.length === 0 ? (
//         <div className="text-gray-500">No blogs found.</div>
//       ) : (
//         <>
//           <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
//             {blogs.map((blog) => (
//               <BlogCard key={blog._id} blog={blog} />
//             ))}
//           </div>

//           <div className="mt-8 flex items-center justify-between">
//             <button
//               className="rounded-xl border bg-white px-4 py-2 text-gray-700 hover:bg-gray-50 disabled:opacity-40"
//               onClick={() => setPage((p) => Math.max(1, p - 1))}
//               disabled={!hasPrev || isFetching}
//             >
//               ← Previous
//             </button>
//             <div className="text-sm text-gray-500">
//               Page {currentPage}
//               {isFetching && <span className="ml-2 animate-pulse">Refreshing…</span>}
//             </div>
//             <button
//               className="rounded-xl border bg-white px-4 py-2 text-gray-700 hover:bg-gray-50 disabled:opacity-40"
//               onClick={() => setPage((p) => p + 1)}
//               disabled={!hasNext || isFetching}
//             >
//               Next →
//             </button>
//           </div>
//         </>
//       )}
//     </section>
//   );
// }

// src/features/blogs/public/BlogsList.jsx
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useGetPublicBlogsQuery } from '../blogsApiSlice';
import BlogCard from '../components/BlogCard';

export default function BlogsList() {
  const [page, setPage] = useState(1);
  const limit = 9;

  const { data, isLoading, isError, error, isFetching } = useGetPublicBlogsQuery(
    { page, limit },
    {
      onSuccess: (data) => console.log('Query success:', data),
      onError: (error) => console.log('Query error:', error),
    }
  );

  console.log('Raw data:', data);

  const blogs = data?.docs || [];
  const hasNext = data?.hasNextPage;
  const hasPrev = data?.hasPrevPage;
  const currentPage = data?.page ?? page;
  const totalPages = data?.totalPages ?? 1;
  const totalDocs = data?.totalDocs ?? blogs.length;

  return (
    <div className="bg-white text-slate-900">
      {/* Hero / Header */}
      <section className="relative overflow-hidden border-b border-slate-200/80">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(14,165,233,0.10),transparent_28%),radial-gradient(circle_at_top_right,rgba(168,85,247,0.10),transparent_30%),linear-gradient(to_bottom,#ffffff,#f8fafc)]" />
        <div className="relative mx-auto max-w-7xl px-4 pb-12 pt-14 sm:px-6 lg:px-8 lg:pb-16 lg:pt-20">
          <div className="max-w-3xl">
            <div className="inline-flex items-center rounded-full border border-slate-200 bg-white/80 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-600 shadow-sm backdrop-blur">
              Artikel & Insight
            </div>

            <h1 className="mt-6 text-4xl font-semibold tracking-tight text-slate-950 sm:text-5xl">
              Tulisan seputar produk,
              <span className="block bg-gradient-to-r from-sky-600 via-cyan-500 to-violet-600 bg-clip-text text-transparent">
                implementasi, dan pengalaman membangun solusi.
              </span>
            </h1>

            <p className="mt-5 max-w-2xl text-lg leading-8 text-slate-600">
              Kumpulan artikel yang membahas pengembangan produk, implementasi teknis,
              insight bisnis, dan pendekatan praktis dalam membangun solusi digital.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/"
                className="rounded-xl border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
              >
                ← Kembali ke Beranda
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Summary strip */}
      <section className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="grid gap-4 sm:grid-cols-3">
          <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="text-2xl font-semibold text-slate-950">{totalDocs}</div>
            <div className="mt-1 text-sm text-slate-600">Total artikel</div>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="text-2xl font-semibold text-slate-950">{currentPage}</div>
            <div className="mt-1 text-sm text-slate-600">Halaman aktif</div>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
            <div className="text-2xl font-semibold text-slate-950">{totalPages}</div>
            <div className="mt-1 text-sm text-slate-600">Total halaman</div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="mx-auto max-w-7xl px-4 pb-16 pt-4 sm:px-6 lg:px-8 lg:pb-24">
        {isLoading ? (
          <div className="rounded-[28px] border border-slate-200 bg-white p-10 shadow-sm">
            <div className="flex flex-col items-center justify-center text-center">
              <div className="h-10 w-10 animate-spin rounded-full border-2 border-slate-200 border-t-sky-600" />
              <p className="mt-4 text-sm font-medium text-slate-600">Sedang memuat artikel...</p>
            </div>
          </div>
        ) : isError ? (
          <div className="rounded-[28px] border border-red-200 bg-red-50 p-10 shadow-sm">
            <div className="max-w-2xl">
              <div className="text-sm font-semibold uppercase tracking-[0.18em] text-red-600">
                Gagal memuat data
              </div>
              <h2 className="mt-3 text-2xl font-semibold text-red-900">
                Terjadi kendala saat mengambil daftar artikel
              </h2>
              <p className="mt-3 text-sm leading-7 text-red-700">
                {error?.data?.message ?? 'Failed to load blogs'}
              </p>
            </div>
          </div>
        ) : blogs.length === 0 ? (
          <div className="rounded-[28px] border border-slate-200 bg-slate-50 p-10 shadow-sm">
            <div className="max-w-2xl">
              <div className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">
                Belum ada artikel
              </div>
              <h2 className="mt-3 text-2xl font-semibold text-slate-900">
                Konten blog belum tersedia
              </h2>
              <p className="mt-3 text-sm leading-7 text-slate-600">
                Nanti bagian ini akan menampilkan artikel, insight, dan tulisan pendukung
                seputar produk serta implementasi solusi.
              </p>
            </div>
          </div>
        ) : (
          <>
            <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <div className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">
                  Daftar Artikel
                </div>
                <h2 className="mt-2 text-2xl font-semibold tracking-tight text-slate-950">
                  Insight, update, dan catatan implementasi
                </h2>
              </div>

              <div className="text-sm text-slate-500">
                Menampilkan halaman <span className="font-semibold text-slate-700">{currentPage}</span>
                {isFetching && (
                  <span className="ml-2 inline-flex items-center rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-xs font-medium text-sky-700">
                    Memperbarui...
                  </span>
                )}
              </div>
            </div>

            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {blogs.map((blog) => (
                <BlogCard key={blog._id || blog.slug} blog={blog} />
              ))}
            </div>

            <div className="mt-10">
              <div className="flex flex-col gap-4 rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm sm:flex-row sm:items-center sm:justify-between">
                <button
                  className="rounded-xl border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40"
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  disabled={!hasPrev || isFetching}
                >
                  ← Sebelumnya
                </button>

                <div className="text-center text-sm text-slate-600">
                  Halaman <span className="font-semibold text-slate-900">{currentPage}</span> dari{' '}
                  <span className="font-semibold text-slate-900">{totalPages}</span>
                </div>

                <button
                  className="rounded-xl bg-slate-950 px-5 py-3 text-sm font-semibold text-white transition hover:bg-black disabled:cursor-not-allowed disabled:opacity-40"
                  onClick={() => setPage((p) => p + 1)}
                  disabled={!hasNext || isFetching}
                >
                  Berikutnya →
                </button>
              </div>
            </div>
          </>
        )}
      </section>
    </div>
  );
}